// removed by extract-text-webpack-plugin
module.exports = {"root":"root--278c7","devexpressFixes":"devexpressFixes--00127","bottomArea":"bottomArea--b8c13","content":"content--e42bb","contentWithPadding":"contentWithPadding--c140a"};